import { Box, Text } from "@mantine/core";
import {
  type RowAlign,
  type RowVariant,
  rowTextStyle,
} from "./DocumentHeaderStyles";

interface InfoRowProps {
  label: string;
  value: string;
  minWidth?: number;
  variant?: RowVariant;
  align?: RowAlign;
}

export function InfoRow({
  label,
  value,
  minWidth = 82,
  variant = "row",
  align = "left",
}: InfoRowProps) {
  const baseStyle = rowTextStyle(variant);
  const labelStyle: React.CSSProperties = {
    ...baseStyle,
    textTransform: "uppercase",
    flexShrink: 0,
    ...(align === "left" ? { minWidth } : {}),
  };
  const containerStyle: React.CSSProperties = {
    display: "flex",
    gap: 6,
    alignItems: "baseline",
    ...(align === "right" ? { justifyContent: "space-between" } : {}),
  };

  return (
    <Box style={containerStyle}>
      <Text style={labelStyle}>{label}:</Text>
      <Text style={baseStyle}>{value || "—"}</Text>
    </Box>
  );
}
